// The authoritative Orator mark: oval "O" enclosing a check — "canvassed / done".
// Geometry copied EXACTLY from docs/brand/orator-mark.svg (icon space 0..512, centre 256,256,
// group scaled 0.92). Do not eyeball a redraw: docs/brand/README.md names that file and
// orator-icon.svg as the single authoritative source, and gen_brand.py renders every raster
// from them. A hand-tuned copy here is how the old circle-and-bar mark survived the 7/26
// rebrand on this surface while every favicon was already correct.
//
// Tile uses the FLAT accent token rather than the brand gradient — the README specifies the flat
// token for app chrome (#1a8a4a light / #3fc079 dark). It also sidesteps duplicate gradient ids
// when several instances render on one page.
export function Logo({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" role="img" aria-label="Orator">
      <rect width="512" height="512" rx="112" fill="var(--accent)" />
      <g
        transform="translate(256,256) scale(0.92) translate(-256,-256)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <ellipse cx="256" cy="256" rx="112" ry="140" strokeWidth="50" />
        <path d="M216,258 l28,30 l54,-66" strokeWidth="30" />
      </g>
    </svg>
  );
}
